import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from '@authentication/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AeroplantasService } from '../../services/aeroplantas.service';
import { AsignarAeroplantasDetalleComponent } from '../asignar-aeroplantas-detalle/asignar-aeroplantas-detalle.component';
import { UsuarioService } from '@account/usuario.service';
import { Asignacion } from '@shared/models/usuarios/Asignacion';
import { Subscription } from 'rxjs';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-asignar-aeroplantas-container',
  templateUrl: './asignar-aeroplantas-container.component.html',
  styleUrl: './asignar-aeroplantas-container.component.scss'
})
export class AsignarAeroplantasContainerComponent implements OnInit, OnDestroy {

  listaAsignaciones: any[];
  listaAsignacionesFiltradas: any[];
  loading: boolean;
  buscadorFormControl = new FormControl();
  cargandoLista: boolean;
  asignacionSeleccionada: Asignacion | null = null;
  subscription: Subscription;
  TipoUsuario = TipoUsuario;

  constructor(  private modalService: NgbModal,
                public aeroplantasService: AeroplantasService,
                private usuarioService: UsuarioService,
                private spinner: NgxSpinnerService,
                public authService: AuthService) { 
                  this.subscription = this.aeroplantasService.recargarAsignaciones$.subscribe((value) => {
                    if (value) {
                      this.loadData(true);
                    }
                  })
                }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  loadData(reload?: boolean) {
    this.handleSpinner(true);
    reload ? this.obtenerAsignaciones() : this.obtenerRoles();
  }

  obtenerRoles() {
    this.usuarioService.obtenerTodosLosRoles()
      .subscribe(roles => {
        this.aeroplantasService.listaRoles.set(roles.sort((a, b) => { if (a.nombre > b.nombre) { return 1 } else { return -1 } }));        
        this.obtenerAsignaciones();
      }, () => {
        this.handleSpinner(false);
      });
  }

  obtenerAsignaciones() {
    this.aeroplantasService.getAsignaciones().subscribe((r) => {
      this.listaAsignaciones = r;
      this.listaAsignacionesFiltradas = r;
      this.handleSpinner(false);
    }, () => {
      this.handleSpinner(false);      
    })
  }

  handleSpinner(load: boolean) {
    load ? this.spinner.show('spinnerLista') : this.spinner.hide('spinnerLista');
    this.loading = load;
  }

  filtrarAsignacionPorTextoBusqueda(){
    const textoBuscado = this.buscador.value;

    this.listaAsignacionesFiltradas = this.listaAsignaciones.filter(g => {
      let agregar = true;
      if (textoBuscado && textoBuscado.length>2) {
        agregar = g.nombreAsignacion.toLowerCase().indexOf(textoBuscado.toLowerCase()) > -1;
      }
      return agregar;
    });
  }

  crearNuevoGrupo(){
    const modalRef = this.modalService.open(AsignarAeroplantasDetalleComponent, { centered: true, size: 'lg', backdrop: "static" });
    modalRef.result.then((grupo) => {
      if(grupo){
        this.asignacionSeleccionada = null;
        this.loadData();
      }
    });
  }

  usuarioSeleccionoAsignacion(a: Asignacion){
    this.asignacionSeleccionada = a;
  }

  get buscador() {
    return this.buscadorFormControl;
  }
}
